const APP_CONSTANTS = {
  BASENAME: process.env.REACT_APP_BASENAME,
  USER_SESSION_LIMIT_HRS: 24, // 1 day,
  VEHICLE_NO_MAX_LENGTH: 10,
  VEHICLE_REG_NO_REGEX: /^[A-Z]{2}[0-9]{1,2}[A-Z]{0,3}[0-9]{4}$/,
  TRUCK_DETAIL_LOADING_MIN_DELAY: 4000, // 4 seconds
  TRACKING_DETAIL_LOADING_MIN_DELAY: 2000, // 2 seconds
  MAX_PHONE_NO_LENGTH: 10,
  MAX_EMAIL_LENGTH: 320,
  LOGIN_OTP_LENGTH: 6,
  OTP_RESEND_COUNTDOWN_TIME: 30, //15 seconds
  OTP_VALIDATION_ATTEMPT_LIMIT: 5,
  OTP_REQUEST_LIMIT: 3,
  DASH_NAV_COLLAPSE_BP: "1100px",
};

export default APP_CONSTANTS;
